import api from './';

export const listarResumosPendentes = async (obj) => {
    const { data } = await api.get('/distribuicao-fiscal/listarResumos', { params: obj });

    return data;
};

export const listarDocumentosSemMovimento = async (obj) => {
    const { data } = await api.get('/distribuicao-fiscal/listarDocumentosSemMovimento', {
        params: obj,
    });

    return data;
};
export const prepararDocumentoSemMovimento = async ({ documentoFiscalDistribuidoId, is_cEANTrib = false }) => {
    try {
        const { data } = await api.post('/distribuicao-fiscal/prepararDocumentoSemMovimento', {
            documentoFiscalDistribuidoId,
            is_cEANTrib,
        });

        return data;
    } catch (error) {
        console.error('Erro ao preparar XML persistido:', {
            message: error?.response?.data?.message || error?.message,

            status: error?.response?.status,

            code: error?.response?.data?.code,
        });

        return (
            error?.response?.data || {
                message: 'Erro inesperado ao carregar o XML persistido.',

                type: 'error',

                code: 'ERRO_CARREGAR_XML_PERSISTIDO',
            }
        );
    }
};

export const baixarDocumento = async ({ distribuicaoFiscalDocumentoResumoId }) => {
    try {
        const { data } = await api.post('/distribuicao-fiscal/baixarDocumento', {
            distribuicaoFiscalDocumentoResumoId,
        });

        return data;
    } catch (error) {
        console.error('Erro ao baixar documento fiscal:', {
            resumoId: distribuicaoFiscalDocumentoResumoId,

            message: error?.response?.data?.message || error?.message,

            status: error?.response?.status,

            code: error?.response?.data?.code,
        });

        return (
            error?.response?.data || {
                message: 'Erro inesperado ao baixar o documento fiscal.',

                type: 'error',

                code: 'ERRO_DOWNLOAD_DOCUMENTO_FISCAL',
            }
        );
    }
};
